import React from "react";


const InquiryHistory = ({ inquiryHistory }) => {
  const formatDateTime = (datetime) => {
    const dateObj = new Date(datetime);
    const date = dateObj.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    const time = dateObj.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit'
    });
    return { date, time };
  };

  return (
    <div>
      <div className="accordion accordion-flush mt-4" id="accordionFlushExample">
        <div className="accordion-item mb-4">
          <h2 className="accordion-header" id="flush-heading-1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse-1"
              aria-controls="flush-collapse-1"
            >
              Inquiry History
            </button>
          </h2>
          <div
            id="flush-collapse-1"
            className="accordion-collapse collapse show"
            aria-labelledby="flush-heading-1"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body" style={{ backgroundColor: '#F5F5F5' }}>
              <div className="messages">
                {inquiryHistory && inquiryHistory.length > 0 ? (
                  inquiryHistory.map((entry, index) => {
                    const isBuyer = entry.actor === "BUYER";
                    const isSystem = entry.actor === "SYSTEM";
                    const { date, time } = formatDateTime(entry.date);
                    return (
                      <div
                        key={index}
                        className={`message ${isBuyer ? "received" : "sent"}`}
                      >
                        <div className="message-content">
                          <p className="mb-1">
                            <strong>{ entry.action }</strong>
                          </p>
                          <p className="mb-1">
                            { entry.description}
                          </p>
                          {isSystem && (
                            <div className="text-info small mb-1">
                              — SYSTEM
                            </div>
                          )}
                          <div className="message-time">
                            {date} • {time}
                            {!isBuyer && !isSystem && (
                              <span className="status sent">✓</span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p>No inquiry history available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryHistory;
